import * as React from "react";
import { AUMPerformanceTableModel } from "../../../../../../Wrap/Models/Models/Business/AssetUnderManagement/AUMPerformanceTableModel";
import { AumContent } from "../../Resource/Content";
import AumTile from "./AumTile";

interface IAumBreakdownProps {
    data?: AUMPerformanceTableModel;
    isLoading: boolean;
}

const AumBreakdown = (props: IAumBreakdownProps) => {
    return (
        <div className="aum-container row pb-21">
            <div className="col-12 col-xs-6 col-sm-3 col-equalise">
                <AumTile
                    isLoading={props.isLoading}
                    title={AumContent.currentAssetHoldings}
                    amount={props.data?.Assets}
                />
            </div>
            <div className="col-12 col-xs-6 col-sm-3 col-equalise">
                <AumTile
                    isLoading={props.isLoading}
                    title={AumContent.pendingCashTransfersIn}
                    amount={props.data?.PendingCashTransfers}
                />
            </div>
            <div className="col-12 col-xs-6 col-sm-3 col-equalise">
                <AumTile
                    isLoading={props.isLoading}
                    title={AumContent.pendingAssetTransfersIn}
                    amount={props.data?.PendingReregisteredAssets}
                />
            </div>
            <div className="col-12 col-xs-6 col-sm-3 col-equalise">
                <AumTile
                    isLoading={props.isLoading}
                    title={AumContent.totalAssetHoldings}
                    amount={props.data?.TotalAssets}
                    includeOperator={false}
                />
            </div>
        </div>
    );
};

export default AumBreakdown;
